import header from './layout/header'
import footer from './layout/footer'
import layout from './layout/layout'

import trip_search from './components/trip-search'
import signin from './components/signin'
import shopping_cart from './components/shopping-cart'

import account_index from './pages/account.index'
import account_orders from './pages/account.orders'
import account_order from './pages/account.order'
import account_change_password from './pages/account.change-password'
import account_profile from './pages/account.profile'
import account_delete_account from './pages/account.delete-account'
import account_delete_success from './pages/account.delete-success'

import change from './pages/change'
import cancellation from './pages/cancellation'
import home from './pages/home'
import trips from './pages/trips'
import checkout from './pages/checkout'
import forget_password from './pages/forget-password'
import reset_password from './pages/reset-password'
import landing from './pages/landing'
import failed from './pages/failed'
import signup from './pages/signup'
import success from './pages/success'

export default {
    header: header,
    footer: footer,
    layout: layout,
    components: {
        trip_search: trip_search,
        signin: signin,
        shopping_cart: shopping_cart,
    },
    pages: {
        home: home,
        trips: trips,
        checkout: checkout,
        landing: landing,
        failed: failed,
        signup: signup,
        success: success,
        cancellation: cancellation,
        change: change,
        forget_password: forget_password,
        reset_password: reset_password,
        account: {
            index: account_index,
            orders: account_orders,
            order: account_order,
            change_password: account_change_password,
            profile: account_profile,
            delete_account: account_delete_account,
            delete_success: account_delete_success
        }
    }
}
